import { createSelector } from "reselect"
import { chain } from "lodash"
import { getAllItems, getSelectedCategory } from "./exposure"

export const getOrderedCategoryItems = createSelector(
  [getAllItems, getSelectedCategory],
  (items, selectedCategory) => {
    return chain(items)
      .filter(item => item.category === selectedCategory)
      .orderBy([item => item.favorite, item => Math.abs(item.lastValue)], ["asc", "desc"])
      .value()
  },
)
